import { render, staticRenderFns } from "./ib-container.vue?vue&type=template&id=2c6bfe9c&lang=pug&"
import script from "./ib-container.vue?vue&type=script&lang=js&"
export * from "./ib-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6bfe9c')) {
      api.createRecord('2c6bfe9c', component.options)
    } else {
      api.reload('2c6bfe9c', component.options)
    }
    module.hot.accept("./ib-container.vue?vue&type=template&id=2c6bfe9c&lang=pug&", function () {
      api.rerender('2c6bfe9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ib-container.vue"
export default component.exports